import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="drop, water, precipitation, liquid"><path d="M13.7914 2.75518C12.7955 1.74665 11.2045 1.74665 10.2086 2.75518C9.15198 3.82517 7.61537 5.52064 6.33827 7.49132C5.07184 9.44557 4 11.7621 4 14.0556C4 18.4486 7.58717 22 12 22C16.4128 22 20 18.4486 20 14.0556C20 11.7621 18.9282 9.44557 17.6617 7.49132C16.3846 5.52064 14.848 3.82517 13.7914 2.75518Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDrop;
